import React from 'react';
import { Link } from 'react-router-dom';
import { AuthForm } from '../components/auth/AuthForm';

export default function SignUp() {
  // Récupérer le plan sélectionné du localStorage
  const selectedPlan = localStorage.getItem('selectedPlan');
  const planInfo = selectedPlan ? JSON.parse(selectedPlan) : null;

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">
            Create an account
            {planInfo && (
              <span className="block text-lg text-indigo-400 mt-2">
                Plan {planInfo.tier} - {planInfo.billingPeriod === 'yearly' ? 'Yearlyl' : 'Monthly'}
              </span>
            )}
          </h2>
          <p className="mt-2 text-gray-400">
            Or{' '}
            <Link to="/signin" className="text-indigo-400 hover:text-indigo-300">
              log in to your account
            </Link>
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl p-8 rounded-2xl border border-white/10">
          <AuthForm mode="signup" />
        </div>
      </div>
    </div>
  );
}